import React from 'react';
import PropTypes from 'prop-types';
import * as Ui from './styles';
import { ExportIcon } from '../../../Icons';

const propTypes = {
  /**
   * Titulo a ser exibido no menu
   */
  title: PropTypes.string,
  /**
   * Titulo de hover do menu
   */
  hoverTitle: PropTypes.string,
  /**
   * Callback para click no menu
   */
  onMenuClick: PropTypes.func,
};

const defaultProps = {
  title: 'Exportar...',
  hoverTitle: 'Exporte o gráfico no formato de sua preferência.',
  onMenuClick: null,
};

/**
 * Componente de item de menu, que serve de gatilho
 * para a definicao de anotacoes para os resultados
 * exibidos em um card
 */
function CardExportMenu(props) {
  // props from parent
  const { onMenuClick, title, hoverTitle, className } = props;

  function onClick() {
    if (onMenuClick) {
      onMenuClick();
    }
  }

  return (
    <Ui.Container className={`CardExportMenu-wrapper ${className}`} onClick={onClick} title={hoverTitle}>
      <Ui.IconContainer>
        <ExportIcon />
      </Ui.IconContainer>
      <span>{title}</span>
    </Ui.Container>
  );
}

CardExportMenu.propTypes = propTypes;
CardExportMenu.defaultProps = defaultProps;

export default CardExportMenu;
